var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23858 2.23858 0 5 0H27C29.7614 0 32 2.23858 32 5V27C32 29.7614 29.7614 32 27 32H5C2.23858 32 0 29.7614 0 27V5Z",
    fill: "#6CC18F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51758 23.4941C6.96529 23.4941 6.51758 23.0464 6.51758 22.4941V9.67596C6.51758 9.12367 6.96529 8.67596 7.51758 8.67596H10.0462C10.2842 8.67596 10.5145 8.76086 10.6955 8.91541L20.0263 16.8811C20.3508 17.1581 20.8509 16.9275 20.8509 16.5008V9.49414C20.8509 8.94186 21.2986 8.49414 21.8509 8.49414H24.5176C25.0699 8.49414 25.5176 8.94186 25.5176 9.49414V22.3123C25.5176 22.8646 25.0699 23.3123 24.5176 23.3123H21.9889C21.7509 23.3123 21.5207 23.2274 21.3397 23.0729L12.0089 15.1072C11.6843 14.8302 11.1842 15.0608 11.1842 15.4875V22.4941C11.1842 23.0464 10.7365 23.4941 10.1842 23.4941H7.51758Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.b5f66486e9e465bc609dbb3155ba105b.svg";
export { ForwardRef as ReactComponent };